<template>
    <div :class="['bookparts-list', classes]">
        <transition name="fade" appear>
            <div v-if="loading" v-t="loadingText" class="bookparts-list__alert" />
            <div v-else-if="parts.length" class="bookparts-list__wrapper">
                <template v-for="(bookpart, idx) in parts">
                    <slot name="part" :part="bookpart">
                        <div
                            v-if="!!getBookpart(bookpart)"
                            :key="bookpart.id"
                            class="bookparts-list__part"
                        >
                            <slot name="part-prepend" :part="bookpart"></slot>
                            <template v-if="!hidePartTitle">
                                <slot name="part-title" :part="bookpart">
                                    <div class="bookparts-list__part-title">
                                        <slot name="part-title-prepend" :part="bookpart" />
                                        <span v-t="partTitleText" />
                                        <span v-text="`#${++idx}`" />
                                        <slot name="part-title-append" :part="bookpart" />
                                    </div>
                                </slot>
                            </template>
                            <Sentence :part="getBookpart(bookpart)" no-control />
                            <slot name="part-append" :part="bookpart"></slot>
                        </div>
                    </slot>
                </template>
            </div>
            <div v-else v-t="noDataText" class="bookparts-list__alert" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Sentence from '../Sentence/Sentence';

export default {
    name: 'BookpartsList',
    components: {
        Sentence
    },
    inject: {
        isEmbed: {
            default: false
        },
        selector: {
            default: false
        }
    },
    props: {
        parts: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        hidePartTitle: {
            type: Boolean,
            default: false
        },
        noDataText: {
            type: String,
            default: 'bookparts.noData'
        },
        loadingText: {
            type: String,
            default: 'bookparts.loading'
        },
        partTitleText: {
            type: String,
            default: 'bookparts.partTitle'
        },
        bookpartKey: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(['bookRtl']),

        classes() {
            return {
                'bookparts-list--loading': this.loading,
                'bookparts-list--rtl': this.bookRtl
            };
        }
    },

    methods: {
        // for special lists where book part put in property (suggestions etc)
        getBookpart(bookpart) {
            if (!this.bookpartKey) return bookpart;

            return bookpart[this.bookpartKey];
        }
    }
};
</script>

<style lang="scss" src="./BookpartsList.scss"></style>
